import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4cf81f1f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col m-12" }
const _hoisted_3 = { class: "row g-0 efj__headline--small" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "row g-0 justify-content-between jagd__icons--space" }
const _hoisted_6 = {
  key: 0,
  class: "col-2"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "jagd__icons",
  src: "img/icons/jagen.svg",
  alt: "Jagd"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "col-2"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "jagd__icons",
  src: "img/icons/fallwild.svg",
  alt: "Fallwild"
}, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 2,
  class: "col-2"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "jagd__icons",
  src: "img/icons/beobachtung.svg",
  alt: "Beobachtung"
}, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 3,
  class: "col-2"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "jagd__icons",
  src: "img/icons/beobachtungspez.svg",
  alt: "Spezial"
}, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "row g-0 geomap__adjust" }
const _hoisted_19 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GeoMap = _resolveComponent("GeoMap")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, _toDisplayString($setup.componentResource.jagd), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        ($setup.features.jagd == true)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", {
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($setup.wildbuchEintragJagd()), ["prevent"])),
                class: "icon-style d-flex"
              }, _hoisted_8)
            ]))
          : _createCommentVNode("", true),
        ($setup.features.fallwild == true)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", {
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => ($setup.wildbuchFallWild()), ["prevent"])),
                class: "icon-style d-flex"
              }, _hoisted_11)
            ]))
          : _createCommentVNode("", true),
        ($setup.features.beobachtung == true)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", {
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => ($setup.wildbuchBeobachtung()), ["prevent"])),
                class: "icon-style d-flex"
              }, _hoisted_14)
            ]))
          : _createCommentVNode("", true),
        ($setup.features.beobachtungSpezial == true)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", {
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => ($setup.wildbuchBeobachtungSpezial()), ["prevent"])),
                class: "icon-style d-flex"
              }, _hoisted_17)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_GeoMap, _normalizeProps(_guardReactiveProps($setup.geoRequest)), null, 16)
          ])
        ])
      ])
    ])
  ]))
}